import { RevisionListener } from '@/common/RevisionListener';
import { VITE_APP_BASENAME } from '@/config';
import { AuthenticatedGuard } from '@/features/authentication/_components/AuthenticatedGuard';
import { DynamicNavigate } from '@/features/authentication/_components/DynamicNavigate';
import { MasterTableResourceGuard } from '@/features/authentication/_components/MasterTableResourceGuard';
import { ProjectResourceGuard } from '@/features/authentication/_components/ProjectResourceGuard';
import { TenantManagerResourceGuard } from '@/features/authentication/_components/TenantManagerResourceGuard';
import { AuthenticationRoutes } from '@/features/authentication/routes';
import { PinpointProvider } from '@/features/comment/components/pinpoint';
import { CommentCollapsibleSider } from '@/features/comment/components/sider';
import { PageLayout } from '@/features/layout/_components';
import { MasterTableRoutes } from '@/features/master-table/routes';
import { ProfileRoutes } from '@/features/profile/routes';
import { AiChatCollapsibleSider } from '@/features/project/projects/project-detail/_components';
import { ProjectsRoutes } from '@/features/project/projects/routes';
import { AdminRoutes } from '@/features/tenant-manager/routes';
import { WorkflowCollapsibleSider } from '@/features/workflow/components/sider';
import { globalLoader } from '@/lib/react-router';
import { RouterProvider, createBrowserRouter } from 'react-router';

export const AppRoutes = () => {
  const router = createBrowserRouter(
    [
      {
        loader: globalLoader,
        HydrateFallback: () => null,
        children: [
          {
            path: '/login/*',
            element: <AuthenticationRoutes />,
          },
          {
            path: '/',
            element: (
              <AuthenticatedGuard>
                <RevisionListener />
                <PinpointProvider>
                  <PageLayout
                    rightSider={
                      <>
                        <AiChatCollapsibleSider />
                        <CommentCollapsibleSider />
                        <WorkflowCollapsibleSider />
                      </>
                    }
                  />
                </PinpointProvider>
              </AuthenticatedGuard>
            ),
            children: [
              {
                index: true,
                element: <DynamicNavigate />,
              },
              {
                path: '/tenant-manager/*',
                element: (
                  <TenantManagerResourceGuard showDenied>
                    <AdminRoutes />
                  </TenantManagerResourceGuard>
                ),
              },
              {
                path: '/master-table/*',
                element: (
                  <MasterTableResourceGuard showDenied>
                    <MasterTableRoutes />
                  </MasterTableResourceGuard>
                ),
              },
              {
                path: '/profile/*',
                element: <ProfileRoutes />,
              },
              {
                path: '/rs/project/*',
                element: (
                  <ProjectResourceGuard showDenied>
                    <ProjectsRoutes />
                  </ProjectResourceGuard>
                ),
              },
            ],
          },
        ],
      },
    ],
    {
      basename: VITE_APP_BASENAME,
    },
  );
  return <RouterProvider router={router} />;
};
